import { LanguageControl } from 'common/organisms/LanguageControl';
import React, { FC } from 'react';
import styled from 'styled-components';

const LanguageControlWrapper = styled.div`
  position: absolute;
  top: 3rem;
  right: 3rem;
`;

export const WrappedLanguageControl: FC = () => {
  return (
    <LanguageControlWrapper>
      <LanguageControl />
    </LanguageControlWrapper>
  );
};
